import React, { Fragment } from 'react';
import { Divider, Grid, Paper } from '@mui/material';
import { v1 } from 'uuid';
import { SectionForm } from '@tranzact/platform_react-components';
import useCustomerProfile from 'hooks/useCustomerProfile';
var CustomerProfileSections = function (_a) {
    var hasFilter = _a.hasFilter, lmktId = _a.lmktId, getCustomerData = _a.getCustomerData, onFilter = _a.onFilter;
    var sections = useCustomerProfile({
        hasFilter: hasFilter,
        lmktId: lmktId,
        getCustomerData: getCustomerData,
        onFilter: onFilter
    }).sections;
    return sections.map(function (_a, index) {
        var header = _a.header, items = _a.items;
        return (React.createElement(Fragment, { key: v1() },
            React.createElement(Grid, { item: true, borderRadius: 0, component: Paper, p: 2, width: "100%" },
                React.createElement(SectionForm, { header: header, items: items })),
            index < sections.length - 1 ? (React.createElement(Grid, { item: true, pb: 2, width: "100%" },
                React.createElement(Divider, null))) : null));
    });
};
export default CustomerProfileSections;
//# sourceMappingURL=CustomerProfileSections.js.map